<p-dialog header="{{ title | translate }}" [(visible)]="displayModal" [modal]="true" [style]="{width: '90%'}"
    [draggable]="false" [resizable]="false" [closable]="false">
    <p class="m-0">{{ msg | translate }}</p>
    <p-button (click)="closeModal()" label="OK"></p-button>
</p-dialog>
